// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3bHgp","content":"styles_content__1WBX_","selectAll":"styles_selectAll__FCHr1"};